import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getCompanie } from "../../store/actions/companies_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/companies_enum";
import SingleView from "../../components/common/SingleView";
const ViewCompanie = ({
  getCompanie,
  match,
  companie: { loading, companie },
}) => {
  useEffect(() => {
    getCompanie(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          companie && (
            <SingleView
              data={companie}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={companie.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ companie: state.companie });

const mapDispatchToProps = { getCompanie };

export default connect(mapStateToProps, mapDispatchToProps)(ViewCompanie);
